import $ from "jquery";

const order = () => {
    //разбиение числа на разряды
    function numberWithSpaces(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    function parsePrice(value) {
        return parseInt(String(value).replace(/\s/g, ""), 10) || 0;
    }

    function formatRub(amount) {
        return `${numberWithSpaces(amount)}&#8381;`;
    }

    function collectOrderItems() {
        const items = [];

        $('.order__form input[name^="items["][name$="[id]"]').each(function () {
            const name = $(this).attr("name");
            const match = name.match(/items\[(\d+)\]/);
            if (!match) {
                return;
            }

            const idx = match[1];
            items.push({
                id: $(this).val(),
                count: $(`input[name="items[${idx}][_joinData][count]"]`).val(),
                _joinData: {
                    count: $(
                        `input[name="items[${idx}][_joinData][count]"]`,
                    ).val(),
                    discount:
                        $(
                            `input[name="items[${idx}][_joinData][discount]"]`,
                        ).val() || 0,
                },
            });
        });

        return items;
    }

    function setPromocodeMessage(message, isError = false) {
        const messageEl = $(".js-promocode-message");
        messageEl
            .text(message)
            .toggleClass("is-error", isError)
            .toggleClass("is-success", !isError && !!message);
    }

    function getOrderSubtotal() {
        const curr = parsePrice($(".side__content .curr").text());
        const salePromo = $(".side__content .sale-promo").length
            ? parsePrice($(".side__content .sale-promo").text())
            : 0;

        return Math.max(0, curr - salePromo);
    }

    function getMaxSpendPoints() {
        const checkbox = $(".js-spend-points");
        if (!checkbox.length) {
            return 0;
        }

        const availableBonuses =
            parseInt(checkbox.data("max-bonuses"), 10) ||
            parseInt(checkbox.val(), 10) ||
            0;

        return Math.min(availableBonuses, getOrderSubtotal());
    }

    function syncSpendPointsLimit() {
        const checkbox = $(".js-spend-points");
        if (!checkbox.length) {
            return 0;
        }

        const maxSpend = getMaxSpendPoints();
        const totalBalance = parseInt(checkbox.data("max-bonuses"), 10) || 0;

        checkbox.val(maxSpend);

        const hintEl = $(".js-spend-points-hint");
        if (maxSpend > 0 && maxSpend < totalBalance) {
            hintEl.html(
                `Использовать для оплаты · списать до <strong class="js-spend-points-value">${numberWithSpaces(maxSpend)}</strong>`,
            );
        } else if (maxSpend > 0) {
            hintEl.text("Использовать для оплаты");
        }

        if (maxSpend <= 0 && checkbox.is(":checked")) {
            checkbox.prop("checked", false);
            $(".side__content #bonus").remove();
        }

        return maxSpend;
    }

    function updatePriceLabel() {
        const labelEl = $(".js-side-price-label");
        if (!labelEl.length) {
            return;
        }

        const hasPromocode = !!$(".js-promocode-id").val();
        const hasPoints =
            $(".js-spend-points").is(":checked") && getMaxSpendPoints() > 0;

        if (hasPromocode && hasPoints) {
            labelEl.text(
                "Итоговая стоимость с учётом промокода и списанных баллов",
            );
            return;
        }

        if (hasPoints) {
            labelEl.text("Итоговая стоимость с учетом списанных баллов");
            return;
        }

        if (hasPromocode) {
            labelEl.text("Итоговая стоимость с учётом промокода");
            return;
        }

        labelEl.text("Итоговая стоимость");
    }

    function renderBonusSidebar(amount) {
        if (amount <= 0) {
            $(".side__content #bonus").remove();
            return;
        }

        const sidebarBonus = `<div id="bonus">
                            <p>Оплата баллами</p>
                            <p class="bonus-value">${numberWithSpaces(amount)}</p>
                        </div>`;

        if ($(".side__content #bonus").length) {
            $(".side__content #bonus .bonus-value").text(
                numberWithSpaces(amount),
            );
        } else {
            $(".side__content").append(sidebarBonus);
        }
    }

    //функция подсчета цены
    function totalSum() {
        const maxSpend = syncSpendPointsLimit();
        let curr = parsePrice($(".side__content .curr").text());
        let salePromo = $(".side__content .sale-promo").length
            ? parsePrice($(".side__content .sale-promo").text())
            : 0;
        let delivery = parsePrice($(".side__content .delivery").text());
        let bonus = 0;

        if ($(".js-spend-points").is(":checked") && maxSpend > 0) {
            bonus = maxSpend;
            renderBonusSidebar(bonus);
        } else {
            $(".side__content #bonus").remove();
        }

        let total = Math.max(0, curr - salePromo + delivery - bonus);

        $(".side__price .total").html(`${numberWithSpaces(total)} &#8381;`);
        updatePriceLabel();
    }

    totalSum();

    //функция показа полей доставки
    const onDeliveryType = () => {
        let activeDeliveryType = $(".delivery-type a.active").attr(
            "data-delivery-type",
        );
        const hiddenDeliveryTypeInput = $('input[name="order_type_delivery"]');

        //записываем значение типа пользователя в скрытый инпут
        hiddenDeliveryTypeInput.val(activeDeliveryType);

        //скрываем ненужные поля
        $(".form__item[data-delivery-type]")
            .hide()
            .find("input")
            .prop("disabled", true);
        $(`.form__item[data-delivery-type="${activeDeliveryType}"]`)
            .show()
            .find("input")
            .prop("disabled", false);
    };

    //Вызываем при загрузке
    onDeliveryType();

    //функция показа полей оплаты
    const onCitySelect = () => {
        const citySelect = $(".js-order-select-city");
        const hidebaleItems = $(".js-toggle-visible-payment");
        const paymentOptions = $(".pay-type .form__radio");
        const selectCityNotice = $(".js-select-city-notice");
        const guestOtherCityNotice = $(".js-guest-other-city-notice");

        if (!citySelect.length) {
            return;
        }

        const syncPaymentVisibility = () => {
            const cityVal = citySelect.val();

            if (!cityVal) {
                paymentOptions.hide();
                paymentOptions.find('input[type="radio"]:checked').prop("checked", false);
                selectCityNotice.prop("hidden", false);
                guestOtherCityNotice.prop("hidden", true);
                return;
            }

            selectCityNotice.prop("hidden", true);

            if (cityVal === "other") {
                hidebaleItems.hide();
                hidebaleItems.find('input[type="radio"]:checked').prop("checked", false);
                paymentOptions.not(".js-toggle-visible-payment").show();
                guestOtherCityNotice.prop("hidden", false);
            } else {
                paymentOptions.show();
                guestOtherCityNotice.prop("hidden", true);
            }
        };

        syncPaymentVisibility();

        citySelect.on("change", function () {
            $(this).removeClass("error");
            syncPaymentVisibility();
        });

        $(".pay-type").on("click", 'input[type="radio"]', function (e) {
            if (citySelect.val()) {
                citySelect.removeClass("error");
                return;
            }

            e.preventDefault();
            $(this).prop("checked", false);
            citySelect.addClass("error");
        });
    };

    onCitySelect();

    //клик по табам
    $(".delivery-type a").click(function () {
        $(this).addClass("active").siblings().removeClass("active");

        onDeliveryType();
    });

    $(".js-spend-points").on("change", function () {
        totalSum();
    });

    // промокод
    $(".js-apply-promocode").on("click", function () {
        const btn = $(this);
        const promocodeValue = $(".js-promocode-input").val().trim();
        const applyUrl = btn.data("apply-url");

        if (!promocodeValue) {
            setPromocodeMessage("Введите промокод", true);
            return;
        }

        btn.addClass("disabled");
        setPromocodeMessage("");

        $.ajax({
            url: applyUrl,
            type: "POST",
            dataType: "json",
            headers: {
                "X-CSRF-Token": window.csrfToken,
            },
            data: {
                code: promocodeValue,
                items: collectOrderItems(),
            },
            success: function (response) {
                if (!response.success) {
                    $(".js-promocode-id").val("");
                    $(".js-promocode-code").val("");
                    $(".side__content .sale-promo").html(formatRub(0));
                    setPromocodeMessage(
                        response.message || "Не удалось применить промокод",
                        true,
                    );
                    totalSum();
                    return;
                }

                $(".js-promocode-id").val(response.promocode_id || "");
                $(".js-promocode-code").val(
                    response.promocode || promocodeValue,
                );
                $(".side__content .sale-promo").html(
                    formatRub(response.promocode_discount || 0),
                );
                setPromocodeMessage(response.message || "Промокод применён");
                totalSum();
            },
            error: function () {
                setPromocodeMessage("Ошибка при применении промокода", true);
            },
            complete: function () {
                btn.removeClass("disabled");
            },
        });
    });

    $(".js-promocode-input").on("input", function () {
        $(".js-promocode-id").val("");
        $(".js-promocode-code").val("");
        $(".side__content .sale-promo").html(formatRub(0));
        setPromocodeMessage("");
        totalSum();
    });

    //проверка способа доставки
    function deliveryCheckError(form) {
        // таб с радиокнопками
        const radioTab = form.find(
            '.delivery .form__item[data-delivery-type="pickup"]',
        );

        if (radioTab.is(":visible")) {
            if (radioTab.find('input[type="radio"]:checked').length) {
                form.find(".delivery .order__form-title h3").removeAttr(
                    "data-error",
                );

                return true;
            } else {
                form.find(".delivery .order__form-title h3").attr(
                    "data-error",
                    "Выберите способ доставки",
                );
                return false;
            }
        } else {
            form.find(".delivery .order__form-title h3").removeAttr(
                "data-error",
            );

            return true;
        }
    }

    // функция проверки полей при подвтерждении заказа
    function checkRequiredFields(form) {
        const requiredFields = form.find(".required:not([disabled])");

        requiredFields.each(function () {
            const elem = $(this);
            const elemVal = elem.val();

            if (elemVal.length) {
                elem.removeClass("error");
            } else {
                elem.addClass("error");
            }
        });

        // способ оплаты
        const checkedPayment = form.find('.pay-type input[type="radio"]:checked');
        const paymentVisible =
            checkedPayment.length && checkedPayment.closest(".form__radio").is(":visible");

        if (paymentVisible) {
            form.find(".pay-type .order__form-title h3").removeAttr("data-error");
        } else {
            form.find(".pay-type .order__form-title h3").attr(
                "data-error",
                "Выберите способ оплаты",
            );
        }

        const deliveryCheck = deliveryCheckError(form);

        if (
            form.find(".required.error:not([disabled])").length ||
            !paymentVisible ||
            !deliveryCheck
        ) {
            return false;
        }

        return true;
    }

    $(".form.order__form").on("submit", function (e) {
        const form = $(this);

        if (!checkRequiredFields(form)) {
            return false;
        }

        return true;
    });
};

export default order;
